import React from 'react'
import { useHistory, NavLink } from 'react-router-dom'
import Logout from './Logout'
import classes from './Navbar.module.css'
import { useAuth } from '../Context/AuthContext'
import { auth } from '../firebaseConfig'
import { Avatar } from '@material-ui/core'

function Navbar() {
    const history = useHistory();
    const { loggedIn } = useAuth();
    return (
        <nav className={classes.nav}>
            <div className={classes.profile}>
                <h2 classname={classes.heading} onClick={() => history.push("/")}>Degram</h2>
                {auth.currentUser && loggedIn && <Logout />}
            </div>
            { (!auth.currentUser || !loggedIn) && <div className={classes.log5}>
                < h3 > <NavLink activeClassName={classes.log} className={classes.log1} to="/login">Login</NavLink></h3>
                <h3><NavLink className={classes.log1} activeClassName={classes.log} to="/signup">Signup</NavLink></h3>
            </div>}
            { auth.currentUser && loggedIn && <NavLink className={classes.profile} to="/user" className={classes.link} activeClassName={classes.log2}> < Avatar className={classes.avatar}>{auth.currentUser && auth.currentUser.displayName[0].toUpperCase()} </Avatar></NavLink>}

        </nav >
    )
}

export default Navbar
